import * as React from "react";
import { Input,Button,Table} from "antd";
import { connect } from "react-redux";
const { TextArea } = Input;
interface IRemarkProps {
  id:any;
  remarkList:any;
  user:any;
  remark:any;
  tabStatus:any;
  getRemarkList: any;
}

// 修改
class Remark extends React.Component<IRemarkProps, any> {
  state = {
    // remarklist:[],
    remark:"",
    refresh:true,
  };
  constructor(props: IRemarkProps) {
    super(props);
  }

  componentDidMount() {
      this.remarklist();     
   }

  shouldComponentUpdate(nextProps: any, prevState: any) {
    if(nextProps.tabStatus != 'tab2' && !prevState.refresh ){
      this.setState({
        refresh: true,
      });
      return true;
    }
    if(nextProps.tabStatus == 'tab2' && prevState.refresh ){
      this.remarklist();
      return false;
    }
    return true;
  }

  remarklist = () =>{
    this.setState({
      refresh: false,
    });
    const param: any = {
      id: this.props.id
    }; 
    this.props.getRemarkList({
      ...param,
      callback: (data) => {
        // this.setState({
        //    remarklist: data
        // });
      }
     });    
  }

  change = (value) =>{
    this.setState({
      remark: value.target.value,
    });     
  }

  addRemark = () =>{
    const param: any = {
      id: this.props.id,
      remark:this.state.remark
    }; 
    this.props.remark({
      ...param,
      callback: (data) => {
       // console.log(data)
        this.remarklist(); 
      }
     });     
  }


  render() {
    const dataSource = this.props.remarkList;
      
    const columns = [{
      title: '操作时间',
      dataIndex: 'create_time',
      key: 'create_time',
      width: 200,
      className:'th'
    },{
      title: '操作人',
      dataIndex: 'fullname',
      key: 'fullname',
      width: 200,
      className:'th',
      render: (text, row, index) => {
        return (
          <React.Fragment>
                <span>{row.role_name}{row.fullname}</span>
          </React.Fragment>
        );
      }
    },{
      title: '内容',
      dataIndex: 'remark',
      key: 'remark',
      className:'th'
    }];
    
    return (
      <React.Fragment>
           <div className="from-remark">
               <div className="remark-left">
                  <TextArea rows={4} onChange={this.change}  /> 
               </div> 
               <div className="remark-right">
               <Button type="primary" onClick={this.addRemark}>添加备忘录</Button>
               </div>   
               <div className="remark-table">
               <Table className="ddd" bordered={true} expandIconAsCell={false} expandIconColumnIndex={-1} pagination={false} dataSource={dataSource} columns={columns} />
                </div>
           </div>

      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
  user: state.userInfo.user,
  tabStatus: state.orderDetails.tabStatus,
  remarkList: state.orderDetails.remarkList,
});

const mapDispatch = dispatch => {
  return {
    getRemarkList: dispatch.orderDetails.getRemarkList,
    remark: dispatch.orderDetails.remark
  };
};


export default connect(
  mapState ,
  mapDispatch
)(Remark);
